<script setup lang="ts">
import type { IPopularityFeature } from '@/pages/forLaywers/model/types/popularityFeatures';
import PopularityFeature from '@/pages/forLaywers/ui/PopularitySection/PopularityFeature.vue';

const isMobile: boolean = useIsMobile();

const features: IPopularityFeature[] = [
  {
    id: 1,
    mode: '_first',
    countTextLeft: 'с',
    count: '2018',
    countTextRight: 'года',
    text: 'подбираем клиентов для юристов',
  },
  {
    id: 2,
    mode: '_second',
    iconName: 'People',
    count: '6,2',
    countTextRightSmall: 'млн человек',
    text: 'нашли специалиста и получили помощь',
  },
  {
    id: 3,
    mode: '_third',
    count: 'Все',
    text: 'города <br /> России',
  },
];
</script>

<template>
  <div :class="['popularity-features', { _mobile: isMobile }]">
    <ul class="popularity-features__list">
      <li
        v-for="feature of features"
        :key="feature.id"
        :class="['popularity-features__item', feature.mode]"
      >
        <PopularityFeature :feature="feature" :is-mobile="isMobile" />
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.popularity-features {
  &__list {
    display: flex;
    justify-content: space-between;
    margin: 0 -@size-x9;

    @media @tablet {
      margin: 0 -15px;
    }
  }

  &__item {
    width: calc(100% / 3);
    max-width: 352px;
    min-width: 26%;
    margin: 0 @size-x9;

    @media @tablet {
      margin: 0 15px;
    }
  }

  &._mobile &__list {
    .container-m();
    .flex-column(@size-x10);

    align-items: center;
    padding: 42px 69px @size-x9;
  }

  &._mobile &__item {
    width: 100%;
    min-width: 131px;
    margin: 0;

    &._first {
      max-width: 173px;
    }

    &._second {
      max-width: 165px;
    }

    &._third {
      max-width: 131px;
    }
  }
}
</style>
